(function () {
  'use strict';

  function initCookieConsent() {
    var cfg = window.customwearCookie || {};
    var KEY = cfg.storageKey || 'cw_cookie_v2';
    var LEGACY = cfg.legacyKey || 'cw_cookie_consent';
    var DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

    var bar = document.getElementById('cw-cookie-bar');
    if (!bar) {
      return;
    }

    var acceptBtn = document.getElementById('cw-cookie-accept');
    var rejectBtn = document.getElementById('cw-cookie-reject');
    var togglePanelBtn = document.getElementById('cw-cookie-toggle-panel');
    var panel = document.getElementById('cw-cookie-panel');
    var saveBtn = document.getElementById('cw-cookie-save');
    var panelFooter = document.getElementById('cw-cookie-panel-footer');
    var rejectPanelBtn = bar.querySelector('[data-cw-cookie-reject-panel]');
    var acceptPanelBtn = bar.querySelector('[data-cw-cookie-accept-panel]');
    var backdrop = bar.querySelector('[data-cw-cookie-backdrop]');
    var scrollRegion = bar.querySelector('.cw-cookie-bar__scroll');
    var elAnalytics = document.getElementById('cw-cookie-analytics');
    var elMarketing = document.getElementById('cw-cookie-marketing');
    var elPers = document.getElementById('cw-cookie-personalization');

    function isDesktopModal() {
      return DESKTOP_MQ.matches;
    }

    function gtagCmd() {
      if (typeof window.gtag === 'function') {
        return window.gtag;
      }
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      return window.gtag;
    }

    function setAdsRedaction(marketingGranted) {
      try {
        gtagCmd()('set', 'ads_data_redaction', !marketingGranted);
      } catch (e) {}
    }

    /**
     * @param {{ analytics: boolean, marketing: boolean, personalization: boolean }} c
     */
    function applyConsentUpdate(c) {
      var g = gtagCmd();
      var a = !!c.analytics;
      var m = !!c.marketing;
      var p = !!c.personalization;

      g('consent', 'update', {
        ad_storage: m ? 'granted' : 'denied',
        ad_user_data: m ? 'granted' : 'denied',
        ad_personalization: m ? 'granted' : 'denied',
        analytics_storage: a ? 'granted' : 'denied',
        functionality_storage: 'granted',
        personalization_storage: p ? 'granted' : 'denied',
        security_storage: 'granted',
      });
      setAdsRedaction(m);
    }

    function essentialOnly() {
      applyConsentUpdate({ analytics: false, marketing: false, personalization: false });
    }

    function acceptAll() {
      applyConsentUpdate({ analytics: true, marketing: true, personalization: true });
    }

    /**
     * @return {{ mode: string, analytics: boolean, marketing: boolean, personalization: boolean } | null}
     */
    function readStored() {
      try {
        var raw = localStorage.getItem(KEY);
        if (raw) {
          var o = JSON.parse(raw);
          if (o && typeof o === 'object' && o.v === 2) {
            return {
              mode: o.mode || 'custom',
              analytics: !!o.analytics,
              marketing: !!o.marketing,
              personalization: !!o.personalization,
            };
          }
        }
        var leg = localStorage.getItem(LEGACY);
        if (leg === '1') {
          return { mode: 'all', analytics: true, marketing: true, personalization: true };
        }
        if (leg === '0') {
          return { mode: 'essential', analytics: false, marketing: false, personalization: false };
        }
      } catch (e) {}
      return null;
    }

    /**
     * @param {{ mode: string, analytics: boolean, marketing: boolean, personalization: boolean }} state
     */
    function persist(state) {
      try {
        localStorage.setItem(
          KEY,
          JSON.stringify({
            v: 2,
            mode: state.mode,
            analytics: state.analytics,
            marketing: state.marketing,
            personalization: state.personalization,
            ts: Date.now(),
          })
        );
        localStorage.removeItem(LEGACY);
      } catch (e) {}
    }

    function setBodyOpen(open) {
      document.body.classList.toggle('cw-cookie-modal-open', !!open);
    }

    function syncAriaModal() {
      var panelOpen = bar.classList.contains('cw-cookie-bar--panel-open');
      bar.setAttribute('aria-modal', isDesktopModal() || panelOpen ? 'true' : 'false');
    }

    function syncBodyLock() {
      var barVisible = !bar.classList.contains('cw-cookie-bar--dismissed');
      var panelOpen = bar.classList.contains('cw-cookie-bar--panel-open');
      var lock = barVisible && (isDesktopModal() || panelOpen);
      setBodyOpen(lock);
      syncAriaModal();
    }

    function syncPanelFooter(show) {
      if (!panelFooter) {
        return;
      }
      if (show) {
        panelFooter.removeAttribute('hidden');
      } else {
        panelFooter.setAttribute('hidden', '');
      }
    }

    function preventBackgroundScroll(e) {
      if (!bar.classList.contains('cw-cookie-bar--dismissed')) {
        var inScroll = scrollRegion && scrollRegion.contains(e.target);
        if (!inScroll) {
          e.preventDefault();
        }
      }
    }

    function releaseBarFocus() {
      var active = document.activeElement;
      if (active && bar.contains(active)) {
        active.blur();
      }
    }

    function hideBar() {
      releaseBarFocus();
      bar.classList.add('cw-cookie-bar--dismissed');
      bar.setAttribute('aria-hidden', 'true');
      bar.classList.remove('cw-cookie-bar--panel-open');
      if (panel) {
        panel.setAttribute('aria-hidden', 'true');
      }
      if (togglePanelBtn) {
        togglePanelBtn.setAttribute('aria-expanded', 'false');
      }
      syncPanelFooter(false);
      setBodyOpen(false);
      syncAriaModal();
    }

    function showBar() {
      bar.classList.remove('cw-cookie-bar--dismissed');
      bar.removeAttribute('aria-hidden');
      syncBodyLock();
    }

    function closePanel() {
      bar.classList.remove('cw-cookie-bar--panel-open');
      if (panel) {
        panel.setAttribute('aria-hidden', 'true');
      }
      if (togglePanelBtn) {
        togglePanelBtn.setAttribute('aria-expanded', 'false');
      }
      syncPanelFooter(false);
      syncBodyLock();
    }

    function openPanel() {
      bar.classList.add('cw-cookie-bar--panel-open');
      if (panel) {
        panel.setAttribute('aria-hidden', 'false');
      }
      if (togglePanelBtn) {
        togglePanelBtn.setAttribute('aria-expanded', 'true');
      }
      syncPanelFooter(true);
      syncBodyLock();
      if (scrollRegion) {
        scrollRegion.scrollTop = 0;
      }
    }

    function syncFormFromState(st) {
      if (elAnalytics) {
        elAnalytics.checked = !!st.analytics;
      }
      if (elMarketing) {
        elMarketing.checked = !!st.marketing;
      }
      if (elPers) {
        elPers.checked = !!st.personalization;
      }
    }

    function readForm() {
      return {
        analytics: elAnalytics ? elAnalytics.checked : false,
        marketing: elMarketing ? elMarketing.checked : false,
        personalization: elPers ? elPers.checked : false,
      };
    }

    var stored = readStored();
    if (stored) {
      applyConsentUpdate(stored);
      hideBar();
      syncFormFromState(stored);
    } else {
      showBar();
    }

    if (typeof DESKTOP_MQ.addEventListener === 'function') {
      DESKTOP_MQ.addEventListener('change', syncBodyLock);
    } else if (typeof DESKTOP_MQ.addListener === 'function') {
      DESKTOP_MQ.addListener(syncBodyLock);
    }

    document.querySelectorAll('[data-cw-cookie-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (el.tagName === 'A') {
          e.preventDefault();
        }
        showBar();
        openPanel();
      });
    });

    if (togglePanelBtn && panel) {
      togglePanelBtn.addEventListener('click', function () {
        if (bar.classList.contains('cw-cookie-bar--panel-open')) {
          closePanel();
        } else {
          openPanel();
        }
      });
    }

    if (rejectBtn) {
      rejectBtn.addEventListener('click', function () {
        essentialOnly();
        persist({
          mode: 'essential',
          analytics: false,
          marketing: false,
          personalization: false,
        });
        syncFormFromState({ analytics: false, marketing: false, personalization: false });
        closePanel();
        hideBar();
      });
    }

    if (rejectPanelBtn) {
      rejectPanelBtn.addEventListener('click', function () {
        if (rejectBtn) {
          rejectBtn.click();
          return;
        }
        essentialOnly();
        persist({
          mode: 'essential',
          analytics: false,
          marketing: false,
          personalization: false,
        });
        syncFormFromState({ analytics: false, marketing: false, personalization: false });
        closePanel();
        hideBar();
      });
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        acceptAll();
        persist({ mode: 'all', analytics: true, marketing: true, personalization: true });
        syncFormFromState({ analytics: true, marketing: true, personalization: true });
        closePanel();
        hideBar();
      });
    }

    if (acceptPanelBtn) {
      acceptPanelBtn.addEventListener('click', function () {
        if (acceptBtn) {
          acceptBtn.click();
        }
      });
    }

    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var f = readForm();
        applyConsentUpdate(f);
        persist({ mode: 'custom', analytics: f.analytics, marketing: f.marketing, personalization: f.personalization });
        closePanel();
        hideBar();
      });
    }

    bar.addEventListener('touchmove', preventBackgroundScroll, { passive: false });
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        if (isDesktopModal() && bar.classList.contains('cw-cookie-bar--panel-open')) {
          closePanel();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieConsent);
  } else {
    initCookieConsent();
  }
})();
